// extracted by mini-css-extract-plugin
export default {"container":"statusIcon_container__tWhF-","active":"statusIcon_active__GKLH2","inactive":"statusIcon_inactive__xaPxP"};